<template>
    <v-container class="headlines-bg" :class="{'headlines-bg-mobile': $vuetify.breakpoint.smAndDown}" fluid v-if="news != ''">
    <h1 class="" v-if="$vuetify.breakpoint.mdAndUp">WHAT'S NEW</h1>
    <h1 style="text-align:center" v-else>WHAT'S NEW</h1>
    <v-row class="mt-4">
        <v-col cols="12" md="3" sm="12" xs="12">
            <v-img :src="image" class="" max-height=500 :class="{'img-mobile': $vuetify.breakpoint.smAndDown}"></v-img>
        </v-col>
        <v-col cols="12" md="5" sm="12" xs="12" class="pt-0">
            <v-row>
                <v-col>
                    <h2 v-if="news != ''" class="mt-0 mb-4">{{news.title._text}}</h2>
                    <div  v-html="text"></div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Headlines',
    data () {
        return {
            news: '',
            image: '',
            text: '',
            date: ''
        }
    },
        mounted () {
        this.$store.dispatch('setLoading', {variable: 'headlines', value: true}).then(() => {
        this.$axios.get(this.$newsurl).then(response => {
        var convert = response.data.toString("utf8")
        convert.replace(/d:|D:|lp1:/g, "");
        convert.replace(/\r?\n|\r/g, "");
        var object = JSON.parse(this.$xml2json(convert, {compact: true, spaces: 4, cdata: true}))
        this.news = object.rss.channel.item ? object.rss.channel.item[0] : ''
        this.date = object.rss.channel.item[0].pubDate._text
        if (this.news != '') {
            var image = this.news['content:encoded']._cdata.split('/>')
            var txt = image[1].toString().split('<p>The post')
            //var imglength = image[0].indexOf('"',35)
            this.image = image[0].substring(image[0].indexOf("https"),image[0].indexOf("class") -2)
            this.text = txt[0]
        }
        this.$store.dispatch('setLoading', {variable: 'headlines', value: false})
        }).catch((error) => console.log(error))
        })
   },
}
</script>
<style scoped>
.v-slide-group__prev .v-slide-group__next {
    width: 50%!important
}
.headlines-bg {
    background: url('/header-web.png') no-repeat top right;
    min-height: 100vh;
    font-size: 2.5vh;

}
.headlines-bg-mobile {
    background: linear-gradient(to bottom, rgba(0,0,0,0.6) 0%,rgba(0,0,0,0.6) 100%), url('/header-web.png') no-repeat top right;
    min-height: 100vh;
    font-size: 2vh;
    z-index: -1
}
</style>